import { render, staticRenderFns } from "./AssociationsHistoryView.vue?vue&type=template&id=5a734991&scoped=true"
import script from "./AssociationsHistoryView.vue?vue&type=script&lang=js"
export * from "./AssociationsHistoryView.vue?vue&type=script&lang=js"
import style0 from "./AssociationsHistoryView.vue?vue&type=style&index=0&id=5a734991&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a734991",
  null
  
)

export default component.exports